export const TOGGLE_BUTTON_CLICK = "TOGGLE_BUTTON_CLICK";

export const FETCH_WORKORDERS = "FETCH_WORKORDERS";

export const FETCH_WORKORDERS_MAP = "FETCH_WORKORDERS_MAP";
export const FETCH_WORKERS = "FETCH_WORKERS";
export const FETCH_WORKERS_MAP = "FETCH_WORKERS_MAP";
export const FETCH_TICKETS = "FETCH_TICKETS";
export const FETCH_TICKETS_MAP = "FETCH_TICKETS_MAP";
export const FETCH_PRODUCTS = "FETCH_PRODUCTS";
export const FETCH_CUSTOMERS = "FETCH_CUSTOMERS";
export const FETCH_CUSTOMER_SITE = "FETCH_CUSTOMER_SITE";
export const FETCH_WAREHOUSES = "FETCH_WAREHOUSES";
export const FETCH_PRINTERS = "FETCH_PRINTERS";
export const FETCH_USERS = "FETCH_USERS";
export const FETCH_SECURITY_ROLES = "FETCH_SECURITY_ROLES";
export const FETCH_MECHANIC_TYPES = "FETCH_MECHANIC_TYPES";
export const FETCH_CONFIG_EMAIL = "FETCH_CONFIG_EMAIL";
export const FETCH_DATA_ERROR = "FETCH_DATA_ERROR";
// Authentication
export const SET_CURRENT_USER = "SET_CURRENT_USER";

// Search WorkOrders
export const ON_MODAL_CHANGE = "ON_MODAL_CHANGE";
export const ON_PRINT = "ON_PRINT";
export const ON_EMAIL = "ON_EMAIL";
export const ON_INVOICE = "ON_INVOICE";
export const ON_CLOSE = "ON_CLOSE";
export const ON_TIME_CHANGE = "ON_TIME_CHANGE";
export const ON_TICKET_TIME_CHANGE = "ON_TIME_CHANGE";
export const CLOSE_TICKET_MODAL = "CLOSE_TICKET_MODAL";
export const GET_TICKET_SIGNATURE = "GET_TICKET_SIGNATURE";
export const ON_MODAL_COMMENT_ERROR = "ON_MODAL_COMMENT_ERROR";
export const ON_MODAL_COMMENT_SUCCESS = "ON_MODAL_COMMENT_SUCCESS";

// post schedued events
export const POST_DATA_SUCCESS = "POST_DATA_SUCCESS";

export const POST_TICKET_DATA_REQUEST = "POST_TICKET_DATA_REQUEST";

export const PRINT_TAG_REQUEST = "PRINT_TAG_REQUEST";
export const PRINT_TAG_SUCCESS = "PRINT_TAG_SUCCESS";
export const PRINT_TAG_ERROR = "PRINT_TAG_ERROR";

export const PRINT_REQUEST = "PRINT_REQUEST";
export const PRINT_SUCCESS = "PRINT_SUCCESS";
export const PRINT_ERROR = "PRINT_ERROR";
// pick up and delivery
export const FETCH_DELIVERY_TICKET = "FETCH_DELIVERY_TICKET";
export const FETCH_PICKUP_TICKET = "FETCH_PICKUP_TICKET";

export const FETCH_STATUS_CODES = "FETCH_STATUS_CODES";

export const FETCH_PRODUCT_CLASS = "FETCH_PRODUCT_CLASS";
export const FETCH_PRODUCT_GROUP = "FETCH_PRODUCT_GROUP";
export const CLEAR_PRODUCT_GROUP = "CLEAR_PRODUCT_GROUP";

export const FETCH_MECHANICS = "FETCH_MECHANICS";
export const FETCH_DRIVERS = "FETCH_DRIVERS";
export const FETCH_YARD_INSPECTOR = "FETCH_YARD_INSPECTOR";
export const FETCH_REQUESTED_PARTS = "FETCH_REQUESTED_PARTS";

export const SERVER_ERROR_500 = "SERVER_ERROR_500";

export const GET_SRM_RECORD = "GET_SRM_RECORD";
export const PUT_SRM_RECORD = "PUT_SRM_RECORD";
export const POST_SRM_RECORD = "POST_SRM_RECORD";

export const RESET_UNIFIED_FORM = "RESET_UNIFIED_FORM";

export const FETCH_SITES_FROM_SRM = "FETCH_SITES_FROM_SRM";
export const CLEAR_SITES_FROM_SRM = "CLEAR_SITES_FROM_SRM";

export const FETCH_PAYMENT_METHODS = "FETCH_PAYMENT_METHODS";
export const FETCH_PART_FROM_FLASK = "FETCH_PART_FROM_FLASK";

export const SET_IS_LOADING = "SET_IS_LOADING";

// rentalBoard
export const SET_DETAIL = "SET_DETAIL";
export const FETCH_ASSETS = "FETCH_ASSETS";
export const FETCH_NEXT_ASSETS = "FETCH_NEXT_ASSETS";
export const FETCH_ASSET = "FETCH_ASSET";
export const SET_PAGE = "SET_PAGE";
export const FETCH_COLORS = "FETCH_COLORS";
export const SET_COLORS = "SET_COLORS";
export const SET_LAST_UPDATED = "SET_LAST_UPDATED";
export const SET_PREV_SETTING = "SET_PREV_SETTING";
export const GET_CONTRACTS = "GET_CONTRACTS";
export const FETCH_DOCUMENT_STATUS_CODE = "FETCH_DOCUMENT_STATUS_CODE";
export const FETCH_DOCUMENT_STATUS_CODE_DESCRIPTION =
  "FETCH_DOCUMENT_STATUS_CODE_DESCRIPTION";
export const FETCH_DOCUMENT_STATUS_COLOR = "FETCH_DOCUMENT_STATUS_COLOR";
export const UPDATE_DOCUMENT_STATUS_COLOR = "UPDATE_DOCUMENT_STATUS_COLOR";
export const SAVE_RENTALBOARD_URL = "SAVE_RENTALBOARD_URL";
export const INITIALIZE_URL = "INITIALIZE_URL";
export const FETCH_STATUS_TOTAL = "FETCH_STATUS_TOTAL";
export const INITIALIZE_ASSETS = "INITIALIZE_ASSETS";
export const NO_TAX = "NTX";
